import React from "react";
import PropTypes from "prop-types";
import { Dropdown, DropdownButton } from "react-bootstrap";

const { danceCategories } = require("../../../helpers/arrays");

const categoryIcon = {
  venue: "icon-music",
  practica: "icon-music",
  school: "icon-home",
  teacher: "icon-user",
  // radio: "icon-radio",  // hidden for now
  musician: "icon-star",   // artist
  liveMusic: "icon-mic",
  festival: "icon-calendar",
};

const FilterMainBar = ({
  searchBy,
  dayOfWeek,
  ipCity,
  ipCountryName,
  venueView,
  dictionary,
  handleChangeSearchBy,
  handleChangeDate,
  onOpenSearchModal,
  onToggleView,
  capitalize,
  citiesTodaySearchBy,
  handleClickCity,
  onClickCountry,
}) => {
  const currentIcon = `feather ${categoryIcon[searchBy] || "icon-music"}`;

  return (
    <div className="fmb">
      {/* Fila superior: ciudad (dropdown) + lupa */}
      <div className="fmb__top">
        <Dropdown className="fmb__city-dropdown">
          <Dropdown.Toggle as="button" className="fmb__city-btn" bsPrefix="fmb-city">
            <span className="fmb__city-name">{ipCity || "—"}</span>
            <i className="feather icon-chevron-down fmb__city-arrow" />
          </Dropdown.Toggle>

          <Dropdown.Menu className="fmb__city-menu">
            {ipCountryName && (
              <>
                <Dropdown.Item
                  className="fmb__country-item"
                  onClick={onClickCountry}
                >
                  <i className="feather icon-globe fmb__btn-icon" />
                  {ipCountryName}
                </Dropdown.Item>
                <Dropdown.Divider />
              </>
            )}
            {citiesTodaySearchBy.map((city) => (
              <Dropdown.Item
                key={city.cityName || city._id}
                onClick={() => handleClickCity(city)}
              >
                {city.cityName}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>

        <div className="fmb__action-icons">
          <button
            type="button"
            className="fmb__icon-btn"
            onClick={onOpenSearchModal}
            title={dictionary.search || "Search"}
          >
            <i className="feather icon-search" />
          </button>
        </div>
      </div>

      {/* Fila inferior: botones de filtro */}
      <div className="fmb__filters">
        {/* Categoría */}
        <DropdownButton
          title={
            <>
              <i className={`${currentIcon} fmb__btn-icon`} />
              {capitalize(dictionary[searchBy])}
            </>
          }
          variant="outline-primary"
          onSelect={handleChangeSearchBy}
          className="fmb__filter-dropdown"
        >
          {danceCategories.map((cat) => (
            <Dropdown.Item key={cat.id} eventKey={cat.type}>
              {capitalize(dictionary[cat.type])}
            </Dropdown.Item>
          ))}
        </DropdownButton>

        {/* Día — solo para venue / practica */}
        {(searchBy === "venue" ||
          searchBy === "practica") && (
          <Dropdown onSelect={handleChangeDate} className="fmb__filter-dropdown">
            <Dropdown.Toggle variant="outline-primary">
              <i className="feather icon-calendar fmb__btn-icon" />
              {capitalize(dictionary[dayOfWeek] || "By Day")}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {[
                "monday",
                "tuesday",
                "wednesday",
                "thursday",
                "friday",
                "saturday",
                "sunday",
              ].map((day) => (
                <Dropdown.Item eventKey={day} key={day}>
                  {capitalize(dictionary[day])}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        )}

        {/* Toggle mapa / lista */}
        <button
          type="button"
          className="btn btn-outline-primary fmb__view-btn"
          onClick={onToggleView}
        >
          <i
            className={`feather ${
              venueView === "map" ? "icon-list" : "icon-map-pin"
            } fmb__btn-icon`}
          />
          {venueView === "map"
            ? capitalize(dictionary.list)
            : capitalize(dictionary.map)}
        </button>
      </div>
    </div>
  );
};

FilterMainBar.propTypes = {
  searchBy: PropTypes.string.isRequired,
  dayOfWeek: PropTypes.string.isRequired,
  ipCity: PropTypes.string.isRequired,
  ipCountryName: PropTypes.string.isRequired,
  venueView: PropTypes.string.isRequired,
  dictionary: PropTypes.object.isRequired,
  handleChangeSearchBy: PropTypes.func.isRequired,
  handleChangeDate: PropTypes.func.isRequired,
  onOpenSearchModal: PropTypes.func.isRequired,
  onToggleView: PropTypes.func.isRequired,
  capitalize: PropTypes.func.isRequired,
  citiesTodaySearchBy: PropTypes.array.isRequired,
  handleClickCity: PropTypes.func.isRequired,
  onClickCountry: PropTypes.func.isRequired,
};

export default FilterMainBar;
